import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbCarouselModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { MediaModule, PrincipalConfigurationDirectiveModule } from '../../../../shared';
import { BadgeModule } from '../../../../shared/components/badge';
import { PdpImageGalleryComponent } from './pdp-image-gallery.component';

@NgModule({
  declarations: [PdpImageGalleryComponent],
  exports: [PdpImageGalleryComponent],
  imports: [
    CommonModule,
    NzIconModule,
    MediaModule,
    NgbTooltipModule,
    I18nModule,
    BadgeModule,
    PrincipalConfigurationDirectiveModule,
    NgbCarouselModule,
  ],
  providers: [],
})
export class PdpImageGalleryModule {}
